import app from 'flarum/forum/app';
import { composerFields } from './composerLanguage';

/**
 * Asks which language the discussion being written is in, then goes on with
 * what the author was doing, if anything.
 */
export default function chooseLanguage(composer, hideSubmitButton, then) {
  app.modal.show(() => import(/* webpackChunkName: 'forum/components/LanguageDiscussionModal', webpackMode: 'lazy-once' */ '../components/LanguageDiscussionModal'), {
    selected: composerFields(composer).language ?? undefined,
    hideSubmitButton,
    onsubmit: language => {
      composerFields(composer).language = language;
      app.composer.editor?.focus();
      then?.();
    }
  });
}
flarum.reg.add('fof-discussion-language', 'forum/utils/chooseLanguage', chooseLanguage);